export const STATUS_OPTIONS = [
  { value: "published", label: "Active (Published)" },
  { value: "draft", label: "Inactive (Draft)" },
];

// type: text | textarea | image | list | number | checkbox | datetime | select
export const CONTENT_SCHEMAS = {
  services: {
    label: "Services", singular: "Service", primary: "title",
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "description", label: "Short Description", type: "textarea" },
      { name: "who_for", label: "Who It's For", type: "textarea" },
      { name: "next_step", label: "Recommended Next Step", type: "text" },
      { name: "categories", label: "Filter Categories", type: "list", help: "Athletes, Adults, Teams, Online, Volleyball, Camps/Clinics" },
      { name: "icon", label: "Icon (Lucide name)", type: "text", help: "e.g. Zap, Users, Dumbbell, Activity, Gauge, Smartphone" },
      { name: "image_url", label: "Image URL", type: "image" },
      { name: "highlights", label: "Main Benefits", type: "list" },
      { name: "location", label: "Related Location", type: "text", help: "e.g. Lenexa & Independence" },
      { name: "booking_url", label: "Book URL (Exercise.com)", type: "text" },
      { name: "packages_url", label: "Packages URL (Exercise.com)", type: "text" },
    ],
  },
  packages: {
    label: "Packages", singular: "Package", primary: "title",
    fields: [
      { name: "title", label: "Package Name", type: "text", required: true },
      { name: "category", label: "Category", type: "select", optionsFromSetting: "package_filters", options: [
        { value: "Performance", label: "Performance" },
        { value: "Fitness", label: "Fitness" },
        { value: "Camps / Clinics", label: "Camps / Clinics" },
        { value: "Drop-In Options", label: "Drop-In Options" },
        { value: "Mavs Volleyball", label: "Mavs Volleyball" },
        { value: "Online Coaching", label: "Online Coaching" },
      ] },
      { name: "price_label", label: "Price", type: "text", help: "e.g. $149 or FREE" },
      { name: "billing", label: "Billing", type: "text", help: "e.g. per month" },
      { name: "commitment", label: "Commitment Length", type: "text", help: "e.g. 3-month minimum" },
      { name: "access_level", label: "Sessions / Access Level", type: "text", help: "e.g. Unlimited sessions" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "features", label: "Benefits Included", type: "list" },
      { name: "featured", label: "Featured (Most Popular)", type: "checkbox" },
      { name: "cta_label", label: "Checkout Button Label", type: "text" },
      { name: "cta_url", label: "Checkout Link (Exercise.com)", type: "text" },
      { name: "book_intro_url", label: "Book Intro Link", type: "text" },
      { name: "portal_url", label: "App / Portal Link", type: "text" },
      { name: "image_url", label: "Image URL", type: "image" },
    ],
  },
  coaches: {
    label: "Coaches", singular: "Coach", primary: "name",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "role", label: "Role / Title", type: "text" },
      { name: "bio", label: "Bio", type: "textarea" },
      { name: "specialties", label: "Specialties", type: "list" },
      { name: "image_url", label: "Photo URL", type: "image" },
      { name: "cta_url", label: "Booking URL", type: "text" },
    ],
  },
  locations: {
    label: "Locations", singular: "Location", primary: "name",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "address", label: "Street Address", type: "text" },
      { name: "city", label: "City / State / Zip", type: "text" },
      { name: "phone", label: "Phone", type: "text" },
      { name: "hours", label: "Hours", type: "list" },
      { name: "amenities", label: "Amenities", type: "list" },
      { name: "map_url", label: "Map URL", type: "text" },
      { name: "image_url", label: "Image URL", type: "image" },
    ],
  },
  offers: {
    label: "Offers", singular: "Offer", primary: "title",
    fields: [
      { name: "title", label: "Offer Title", type: "text", required: true },
      { name: "description", label: "Description", type: "textarea" },
      { name: "badge_text", label: "Badge Text", type: "text", help: "e.g. LIMITED, SAVE 20%" },
      { name: "who_qualifies", label: "Who Qualifies", type: "textarea" },
      { name: "discount_details", label: "Discount Details", type: "text" },
      { name: "promo_code", label: "Promo Code", type: "text" },
      { name: "terms", label: "Terms & Conditions", type: "textarea" },
      { name: "start_at", label: "Start Date", type: "datetime", help: "Offer goes live on this date" },
      { name: "end_at", label: "End Date", type: "datetime", help: "Offer auto-expires after this date" },
      { name: "cta_label", label: "Button Label", type: "text" },
      { name: "cta_url", label: "Button URL", type: "text" },
      { name: "image_url", label: "Image URL", type: "image" },
    ],
  },
  events: {
    label: "Events", singular: "Event", primary: "title",
    fields: [
      { name: "title", label: "Event Name", type: "text", required: true },
      { name: "description", label: "Description", type: "textarea" },
      { name: "event_type", label: "Event Type", type: "select", options: [
        { value: "Camps", label: "Camps" },
        { value: "Clinics", label: "Clinics" },
        { value: "Evaluations", label: "Evaluations" },
        { value: "Parent Meetings", label: "Parent Meetings" },
        { value: "Team Training", label: "Team Training" },
        { value: "Online", label: "Online" },
        { value: "Community", label: "Community" },
      ] },
      { name: "event_date", label: "Date", type: "datetime" },
      { name: "event_time", label: "Time", type: "text", help: "e.g. 9:00 AM \u2013 12:00 PM" },
      { name: "location", label: "Location", type: "text" },
      { name: "age_group", label: "Age Group", type: "text", help: "e.g. Ages 10\u201318" },
      { name: "skill_level", label: "Skill Level", type: "text", help: "e.g. All Levels" },
      { name: "price", label: "Price", type: "text", help: "e.g. $35 or Free" },
      { name: "capacity", label: "Capacity", type: "text", help: "e.g. 20 spots" },
      { name: "cta_label", label: "Registration Button Label", type: "text" },
      { name: "cta_url", label: "Registration Link", type: "text" },
      { name: "image_url", label: "Image URL", type: "image" },
    ],
  },
  testimonials: {
    label: "Testimonials", singular: "Testimonial", primary: "name",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "category", label: "Category", type: "select", optionsFromSetting: "testimonial_filters", options: [
        { value: "Youth Athletes", label: "Youth Athletes" },
        { value: "Volleyball Athletes", label: "Volleyball Athletes" },
        { value: "College Athletes", label: "College Athletes" },
        { value: "Adult Fitness Clients", label: "Adult Fitness Clients" },
        { value: "Team Results", label: "Team Results" },
        { value: "Transformation Stories", label: "Transformation Stories" },
      ] },
      { name: "role", label: "Role / Tag", type: "text" },
      { name: "filters", label: "Filter (choose one or more)", type: "multiselect", optionsFromSetting: "testimonial_filters", help: "Which filter categories this testimonial appears under on the public Testimonials page. You can pick more than one (e.g. Pro Athlete + Volleyball Athlete). Manage the list in \"Manage Filters\" below." },
      { name: "sport", label: "Sport", type: "text" },
      { name: "school_team", label: "School / Team", type: "text" },
      { name: "quote", label: "Quote", type: "textarea" },
      { name: "result", label: "Measurable Result", type: "text", help: "e.g. Vertical +6 inches" },
      { name: "coach_note", label: "Coach Note", type: "textarea" },
      { name: "rating", label: "Rating (1-5)", type: "number" },
      { name: "featured", label: "Featured", type: "checkbox" },
      { name: "image_url", label: "Photo URL", type: "image" },
      { name: "video_url", label: "Video URL (optional)", type: "text" },
      { name: "social_url", label: "Social Link (optional)", type: "text" },
    ],
  },
  faqs: {
    label: "FAQs", singular: "FAQ", primary: "question",
    fields: [
      { name: "question", label: "Question", type: "text", required: true },
      { name: "answer", label: "Answer", type: "textarea" },
      { name: "category", label: "Category", type: "select", options: [
        { value: "Getting Started", label: "Getting Started" },
        { value: "Pricing/Packages", label: "Pricing/Packages" },
        { value: "Booking", label: "Booking" },
        { value: "App Setup", label: "App Setup" },
        { value: "Cancellations/Rescheduling", label: "Cancellations/Rescheduling" },
        { value: "Membership Commitments", label: "Membership Commitments" },
        { value: "Training Expectations", label: "Training Expectations" },
        { value: "What to Bring", label: "What to Bring" },
        { value: "Parent Questions", label: "Parent Questions" },
        { value: "Mavs Volleyball", label: "Mavs Volleyball" },
        { value: "Online Training", label: "Online Training" },
        { value: "Billing/Payments", label: "Billing/Payments" },
        { value: "Support", label: "Support" },
      ] },
    ],
  },
  posts: {
    label: "News & Posts", singular: "Post", primary: "title",
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "excerpt", label: "Excerpt", type: "textarea" },
      { name: "body", label: "Body", type: "textarea" },
      { name: "image_url", label: "Image URL", type: "image" },
      { name: "link_url", label: "External Link URL (optional)", type: "text" },
      { name: "source", label: "Source / Channel", type: "text", help: "e.g. Trilogy News, Instagram" },
      { name: "published_at", label: "Publish Date", type: "datetime" },
    ],
  },
  policies: {
    label: "Legal / Policies", singular: "Policy", primary: "title",
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "slug", label: "Slug", type: "text", help: "URL key, e.g. privacy, terms, refund, cancellation, waivers" },
      { name: "body", label: "Body (use blank lines for paragraphs)", type: "textarea" },
    ],
  },
  booking_links: {
    label: "Booking Links", singular: "Booking Link", primary: "title",
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "description", label: "Description", type: "textarea" },
      { name: "url", label: "Destination URL (Exercise.com)", type: "text" },
      { name: "button_label", label: "Button Label", type: "text" },
    ],
  },
  volleyball_resources: {
    label: "Volleyball Resources", singular: "Resource", primary: "title",
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "description", label: "Description", type: "textarea" },
      { name: "url", label: "Link URL", type: "text" },
      { name: "button_label", label: "Button Label", type: "text" },
      { name: "icon", label: "Icon (Lucide name)", type: "text", help: "e.g. BookOpen, Calendar, ClipboardList" },
    ],
  },
  page_sections: {
    label: "Page Sections", singular: "Section", primary: "title",
    fields: [
      { name: "title", label: "Internal Label", type: "text", required: true },
      { name: "page", label: "Page", type: "select", options: [
        { value: "about", label: "About" },
        { value: "mavs-volleyball", label: "Mavs Volleyball" },
        { value: "locations", label: "Locations" },
        { value: "services", label: "Training Services" },
      ] },
      { name: "heading", label: "Heading", type: "text" },
      { name: "body", label: "Body", type: "textarea" },
      { name: "image_url", label: "Image URL", type: "image" },
    ],
  },
};

// ---- Role-based access ----
export const ROLE_CONTENT = {
  admin: "ALL",
  editor: ["page_sections", "services", "events", "testimonials", "faqs", "posts"],
  support_manager: [],
};

export const canEditType = (role, type) =>
  role === "admin" || (Array.isArray(ROLE_CONTENT[role]) && ROLE_CONTENT[role].includes(type));
export const canManageSupport = (role) => role === "admin" || role === "support_manager";
export const canManageSettings = (role) => role === "admin";
export const isStaff = (role) => ["admin", "editor", "support_manager"].includes(role);

export const ROLE_LABEL = {
  admin: "Owner / Admin",
  editor: "Staff / Editor",
  support_manager: "Support Manager",
  user: "Member",
};

// Order content types appear in dashboard / nav
export const CONTENT_ORDER = [
  "offers", "events", "packages", "services", "coaches", "locations",
  "testimonials", "faqs", "posts", "page_sections", "booking_links",
  "volleyball_resources", "policies",
];
